module.exports = RedNaoSharedCore.default('shared/core/Store/StoreBase');